/**
 * ! Icons Imports:
 * ! You need to import all the icons which come from the API or from your server and then add these icons in 'icons' variable.
 * ! If you need all the icons from the library, use "import * as Icon from 'mdi-material-ui'"
 * */
import Tab from 'mdi-material-ui/Tab'
import Menu from 'mdi-material-ui/Menu'
import Plus from 'mdi-material-ui/Plus'
import Login from 'mdi-material-ui/Login'
import Table from 'mdi-material-ui/Table'
import Lastpass from 'mdi-material-ui/Lastpass'
import ChartLine from 'mdi-material-ui/ChartLine'
import LockReset from 'mdi-material-ui/LockReset'
import ChartDonut from 'mdi-material-ui/ChartDonut'
import CogOutline from 'mdi-material-ui/CogOutline'
import CardOutline from 'mdi-material-ui/CardOutline'
import CartOutline from 'mdi-material-ui/CartOutline'
import CurrencyUsd from 'mdi-material-ui/CurrencyUsd'
import LockOutline from 'mdi-material-ui/LockOutline'
import Screwdriver from 'mdi-material-ui/Screwdriver'
import StarOutline from 'mdi-material-ui/StarOutline'
import TrayArrowUp from 'mdi-material-ui/TrayArrowUp'
import AlertOutline from 'mdi-material-ui/AlertOutline'
import ClockOutline from 'mdi-material-ui/ClockOutline'
import EmailOutline from 'mdi-material-ui/EmailOutline'
import CalendarRange from 'mdi-material-ui/CalendarRange'
import CircleOutline from 'mdi-material-ui/CircleOutline'
import PencilOutline from 'mdi-material-ui/PencilOutline'
import ShieldOutline from 'mdi-material-ui/ShieldOutline'
import AccountOutline from 'mdi-material-ui/AccountOutline'
import ChartBellCurve from 'mdi-material-ui/ChartBellCurve'
import DotsHorizontal from 'mdi-material-ui/DotsHorizontal'
import FullscreenExit from 'mdi-material-ui/FullscreenExit'
import MessageOutline from 'mdi-material-ui/MessageOutline'
import RadioboxMarked from 'mdi-material-ui/RadioboxMarked'
import TextBoxOutline from 'mdi-material-ui/TextBoxOutline'
import CardPlusOutline from 'mdi-material-ui/CardPlusOutline'
import CardTextOutline from 'mdi-material-ui/CardTextOutline'
import ChartBoxOutline from 'mdi-material-ui/ChartBoxOutline'
import CheckboxOutline from 'mdi-material-ui/CheckboxOutline'
import BookOpenOutline from 'mdi-material-ui/BookOpenOutline'
import FileTreeOutline from 'mdi-material-ui/FileTreeOutline'
import TimelineOutline from 'mdi-material-ui/TimelineOutline'
import ViewGridOutline from 'mdi-material-ui/ViewGridOutline'
import GestureTapButton from 'mdi-material-ui/GestureTapButton'
import HelpCircleOutline from 'mdi-material-ui/HelpCircleOutline'
import SquareEditOutline from 'mdi-material-ui/SquareEditOutline'
import AccountPlusOutline from 'mdi-material-ui/AccountPlusOutline'
import AlertCircleOutline from 'mdi-material-ui/AlertCircleOutline'
import FormatListBulleted from 'mdi-material-ui/FormatListBulleted'
import FormatListCheckbox from 'mdi-material-ui/FormatListCheckbox'
import FormatListNumbered from 'mdi-material-ui/FormatListNumbered'
import VectorArrangeBelow from 'mdi-material-ui/VectorArrangeBelow'
import FileDocumentOutline from 'mdi-material-ui/FileDocumentOutline'
import ToggleSwitchOutline from 'mdi-material-ui/ToggleSwitchOutline'
import ViewGridPlusOutline from 'mdi-material-ui/ViewGridPlusOutline'
import AccountCircleOutline from 'mdi-material-ui/AccountCircleOutline'
import CalendarBlankOutline from 'mdi-material-ui/CalendarBlankOutline'
import ChartTimelineVariant from 'mdi-material-ui/ChartTimelineVariant'
import ChartBellCurveCumulative from 'mdi-material-ui/ChartBellCurveCumulative'
import FormatTextVariantOutline from 'mdi-material-ui/FormatTextVariantOutline'
import CardAccountDetailsOutline from 'mdi-material-ui/CardAccountDetailsOutline'
import CardBulletedSettingsOutline from 'mdi-material-ui/CardBulletedSettingsOutline'
import TransitConnectionHorizontal from 'mdi-material-ui/TransitConnectionHorizontal'
import AccountMultipleRemoveOutline from 'mdi-material-ui/AccountMultipleRemoveOutline'
import CheckboxMultipleBlankOutline from 'mdi-material-ui/CheckboxMultipleBlankOutline'

export const autocompleteIconObj = {
  Tab,
  Menu,
  Plus,
  Login,
  Table,
  Lastpass,
  ChartLine,
  LockReset,
  ChartDonut,
  CogOutline,
  CardOutline,
  CartOutline,
  CurrencyUsd,
  LockOutline,
  Screwdriver,
  StarOutline,
  TrayArrowUp,
  AlertOutline,
  ClockOutline,
  EmailOutline,
  CalendarRange,
  CircleOutline,
  PencilOutline,
  ShieldOutline,
  AccountOutline,
  ChartBellCurve,
  DotsHorizontal,
  FullscreenExit,
  MessageOutline,
  RadioboxMarked,
  TextBoxOutline,
  CardPlusOutline,
  CardTextOutline,
  ChartBoxOutline,
  CheckboxOutline,
  BookOpenOutline,
  FileTreeOutline,
  TimelineOutline,
  ViewGridOutline,
  GestureTapButton,
  HelpCircleOutline,
  SquareEditOutline,
  AccountPlusOutline,
  AlertCircleOutline,
  FormatListBulleted,
  FormatListCheckbox,
  FormatListNumbered,
  VectorArrangeBelow,
  FileDocumentOutline,
  ToggleSwitchOutline,
  ViewGridPlusOutline,
  AccountCircleOutline,
  CalendarBlankOutline,
  ChartTimelineVariant,
  ChartBellCurveCumulative,
  FormatTextVariantOutline,
  CardAccountDetailsOutline,
  CardBulletedSettingsOutline,
  TransitConnectionHorizontal,
  AccountMultipleRemoveOutline,
  CheckboxMultipleBlankOutline,
}
